import {Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Paragraph, Text} = Typography;

const CommunicationOC = () => {
  return (
    <Layout style={{margin: '50px', background: 'inherit'}}>
      <Paragraph className='Title3' style={{color: appColors['ColorX'], marginTop: '-20px'}}>Conclusion</Paragraph>
      <Text className='BaseText'>During this season we managed to bring science-related topics such as cloning, famous people who impacted and contributed to great changes in science, among others, to people of different ages, genders and most importantly different careers through publications, ads and videos on our social networks. <br/>In addition to this, we made different collaborations which allowed us to grow as a team, reminding us that science has no age or limits. We ended this stage very happily, as we were able to <b>effectively communicate the importance of healthy aging</b>.</Text>
    </Layout>
  );
};

export default CommunicationOC;
